<template>
  <svg
    :width="width"
    :height="height"
    version="1.1"
    viewBox="0 0 512 512"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 512.001 512.001"
  >
    <path
      d="m284.29 256 221.86-221.86c7.811-7.811 7.811-20.475 0-28.285s-20.475-7.811-28.285 0l-221.86 221.86-221.86-221.86c-7.811-7.811-20.475-7.811-28.285 0s-7.811 20.475 0 28.285l221.86 221.86-221.86 221.86c-7.811 7.811-7.811 20.475 0 28.285 3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857l221.86-221.86 221.86 221.86c3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857c7.811-7.811 7.811-20.475 0-28.285l-221.86-221.86z" fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "Close1",
  props: {
    width: { type: String, default: "26px" },
    height: { type: String, default: "26px" },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// Close1.vue?6559188e